import React, { useEffect } from 'react'
import {Container} from 'react-bootstrap';
import withAuth from '../components/authHOC';
import { Col, Row, Tabs } from 'antd';

import { IoMdArrowDropright } from 'react-icons/io';
import PaymentPeriodsTable from '../components/PaymentPeriodsTable';
import InterestRatesTable from '../components/InterestRatesTable';
import InstallmentPeriodsTable from '../components/InstallmentPeriodsTable';
import SecurityTypesTable from '../components/SecurityTypesTable';
import IdTypesTable from '../components/IdTypesTable';
import OccupationsTable from '../components/OccupationsTable';
import DistrictsTable from '../components/DistrictsTable';
import { getMetaData } from '../actions/metaActions';
import { useDispatch } from 'react-redux';
import InstitutionPage from './InstitutionPage';

const MetadataPage = () => {

   const tab_items = [

       {
          label: 'Institution',
          key: '1',
          children: <InstitutionPage/>,
        },
        {
          label: 'Interest rates',
          key: '8',
          children: <InterestRatesTable/>,
        },
        {
          label: 'Payment periods',
          key: '3',
          children: <PaymentPeriodsTable/>,
        },{
          label: 'Installment periods',
          key: '4',
          children: <InstallmentPeriodsTable/>
        },
        {
          label: 'Loan Security types',
          key: '2',
          children: <SecurityTypesTable/>,
        },
        {
          label: 'ID Types',
          key: '5',
          children: <IdTypesTable/>,
        },
        {
          label: 'Occupations',
          key: '6',
          children: <OccupationsTable/>,
        },
         {
          label: 'Districts',
          key: '7',
          children: <DistrictsTable/>,
        },
  ]

  const dispatch = useDispatch()

  useEffect(()=>{
    dispatch(getMetaData() as any)
  }, [])


  return (
       <Container fluid id='users-container'>
       <Row className=' justify-content-between align-items-center py-0 g-0'>
        <Col className='text-start py-2'>
         <h4 className='medium text-uppercase fw-bold' style={{color: '#052c65', fontSize: 16}}> <IoMdArrowDropright />Meta Data</h4>
         </Col>     
        </Row>
        <Row>
          <Col>
            <Tabs
              defaultActiveKey="1"
              type="card"
              size={'small'}
              items={tab_items}
            />
         
          </Col>
        </Row>
    </Container>
  )
}
export default withAuth (MetadataPage, ['admin'])